export const productsAuthPaths: Record<string, string> = {
  'create-password': 'Create Your Password',
  'reset-password': 'Reset Your Password',
  'reset-password/request': 'Reset Your Password',
  'verify-email-address': 'Verify Your Email Address',
};
